<!-- =========================================================================================
  File Name: AdminSidebar.vue
  Description: Add admin , Update admin - Sidebar component
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? $t("ADD_NEW_ADMIN") : $t("UPDATE_ADMIN") }} </h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-6">
         <!-- ROLE -->
        <div class="mt-5">
          <label class="vs-select--label">{{$t('ROLE')}}</label>
          <v-select :options="adminRoleOptions" label="text" name="role" :get-option-label="getLabel" v-model="role.roleId" :reduce="option => option.value" v-validate="{ required: true }" :clearable="false" :searchable="false" >
              <template v-slot:option="option">
                {{ $t(option.text) }}
            </template>
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('role')">{{ errors.first('role') }}</span>
        </div>

        <!-- ADD NEW ADMIN -->
        <template v-if="Object.entries(this.data).length === 0">
          <!-- ID -->
          <vs-input :label="$t('ADMIN_ID')" key="admin-new-id" v-model="admin.adminId" class="mt-5 w-full" name="adminId" v-validate="{ required: true, min:6, max:20, alpha_dash: true }" maxlength="21" icon-pack="feather" icon="icon-user" icon-no-border />
          <span class="text-danger text-sm" v-show="errors.has('adminId')">{{ errors.first('adminId') }}</span>

            <!-- NAME -->
          <vs-input :label="$t('ADMIN_NAME')" key="admin-new-name" v-model="admin.name" class="mt-5 w-full" name="adminName"  v-validate="{ max:30, alpha_spaces: true }" maxlength="31" icon-pack="feather" icon="icon-info" icon-no-border/>
          <span class="text-danger text-sm" v-show="errors.has('adminName')">{{ errors.first('adminName') }}</span>


          <!-- EMAIL -->
          <vs-input  :label="$t('EMAIL')" key="admin-new-email" v-model="admin.email" class="mt-5 w-full" name="email" v-validate="{ max:50, required: true, email:true }" maxlength="51" icon-pack="feather" icon="icon-mail" icon-no-border  />
          <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>

          <!-- PASSWORD -->
          <vs-input :label="$t('PASSWORD')" key="admin-password" type="password" v-model="dataPassword" class="mt-5 w-full" name="password" ref="password" v-validate="{ required: this.isRequiredForNew, min:8, max:20, regex:/(?=.{8,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/}" maxlength="21" icon-pack="feather" icon="icon-lock" icon-no-border/>
          <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
          <p class="text-primary text-sm">{{this.$t('PASSWORD_PATTERN')}}</p>

          <!-- CONFIRM PASSWORD -->
          <vs-input :label="$t('CONFIRM_PASSWORD')" key="admin-confirm-password" type="password" v-model="dataConfirmPassword" class="mt-5 w-full" name="confirmPassword" v-validate="{ required: this.isRequiredForNew, min:8, max:20, confirmed:'password' }" maxlength="21" icon-pack="feather" icon="icon-lock" icon-no-border/>
          <span class="text-danger text-sm" v-show="errors.has('confirmPassword')">{{ errors.first('confirmPassword') }}</span>

        </template>

        <!-- UPDATE ADMIN -->
        <template v-if="Object.entries(this.data).length !== 0">
          <!-- ID -->
          <vs-input :label="$t('ADMIN_ID')" key="admin-id" disabled v-model="admin.adminId" class="mt-5 w-full" name="adminId" v-validate="{ required: true }" icon-pack="feather" icon="icon-user" icon-no-border />
          <span class="text-danger text-sm" v-show="errors.has('adminId')">{{ errors.first('adminId') }}</span>

          <!-- NAME -->
          <vs-input :label="$t('ADMIN_NAME')" key="admin-name" v-model="admin.name" class="mt-5 w-full" name="adminName"  v-validate="{ max:30, alpha_spaces: true }" maxlength="31" icon-pack="feather" icon="icon-info" icon-no-border/>
          <span class="text-danger text-sm" v-show="errors.has('adminName')">{{ errors.first('adminName') }}</span>

          <!-- EMAIL -->
          <vs-input  :label="$t('EMAIL')" key="admin-email" v-model="admin.email" class="mt-5 w-full" name="email" v-validate="{ max:50, required: true, email:true }" maxlength="51" icon-pack="feather" icon="icon-mail" icon-no-border  />
          <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>

          <!-- STATUS -->
          <div class="mt-5">
            <label class="vs-select--label">{{$t('ADMIN_STATUS')}}</label>
            <v-select :options="adminStatus" key="admin-status" label="text" name="adminStatus" :get-option-label="getLabel" v-model="admin.adminStatus" :reduce="option => option.value" v-validate="{ required: true }" :clearable="false" :searchable="false" >
                <template v-slot:option="option">
                  {{ $t(option.text) }}
              </template>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('adminStatus')">{{ errors.first('adminStatus') }}</span>
          </div>

          <!-- BLOCKED REASON -->
          <div class="mt-5"  v-if="admin.adminStatus == '3'">
            <label class="vs-select--label">{{$t('BLOCKED_REASON')}}</label>
            <v-select :options="blockedReason" key="admin-blocked-reason" label="text" name="blockedReason" :get-option-label="getLabel" v-model="admin.blockedReason" :reduce="option => option.value" v-validate="{ required: true }" :clearable="false" :searchable="false" >
                <template v-slot:option="option">
                  {{ $t(option.text) }}
              </template>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('blockedReason')">{{ errors.first('blockedReason') }}</span>
          </div>
        </template>

        <div class="mt-6" v-if="Object.entries(this.data).length !== 0" >
           <vs-button  class="w-full" color="warning" @click="checkSubmit('Reset')" :disabled="!isFormValid">{{$t('ADMIN_RESET')}}</vs-button>
           <span class="text-danger text-sm font-bold">{{this.$t('ADMIN_RESET_BUTTON_MESSAGE')}}</span>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-5" @click="checkSubmit('Submit')" :disabled="!isFormValid">{{$t('SUBMIT')}}</vs-button>
      <vs-button  class="mr-5" type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('CLOSE')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  mounted() {
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
        this.isRequiredForNew = true
        this.isRequiredForUpdate = false
      } else {
        this.isRequiredForNew = false
        this.initValues()
        let { role, admin } = JSON.parse(JSON.stringify(this.data))
        this.role = role
        this.admin = admin
        this.$validator.reset()
      }
    },
    dataPassword(val){
      if (Object.entries(this.data).length !== 0 && val !== '') {
        this.isRequiredForUpdate = true
      } else {
        this.isRequiredForUpdate = false
      }
    },
  },
  data() {
    return {

      role:{
        roleId: "",
        roleName: ""
      },
      admin:{
        uuid:"",
        adminId:"",
        adminStatus:"",
        name:"",
        email:"",
        phoneNumber:"",
        blockedReason: ""
      },

      dataPassword: "",
      dataConfirmPassword: "",

      isRequiredForNew: false,
      isRequiredForUpdate: false,
      isRequiredForStatus : false,

      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
        return !this.errors.any()
    },
    adminRoleOptions(){
      return this.$store.state.dataAdmin.adminRoleOptions
    },
    adminStatus(){
      return this.$store.state.dataAdmin.adminStatus
    },
    blockedReason(){
      return this.$store.state.dataAdmin.blockedReason
    }
  },
  methods: {
    initValues() {
      if(this.data.id) return
        this.role.roleId = 2
        this.admin.uuid = ""
        this.admin.adminId = ""
        this.admin.name = ""
        this.dataPassword = ""
        this.dataConfirmPassword = ""
        this.admin.email = ""
        this.admin.phoneNumber = ""
        this.admin.adminStatus = "1"
        this.admin.blockedReason = ""
    },
    checkSubmit(action){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.openConfirm(action)
        }
      })
      .catch((error)=>{
          this.errorAlert(this.$t("ERROR"), error.message)
      })
    },
    submitData() {
        this.$vs.loading()

        const obj = {
          role : {
            roleId : this.role.roleId
          },
          admin : {
            uuid: this.admin.uuid,
            adminId : this.admin.adminId,
            password : this.dataPassword,
            name : this.admin.name,
            email : this.admin.email,
            phoneNumber : this.admin.phoneNumber,
            adminStatus : this.admin.adminStatus,
            blockedReason : this.admin.blockedReason
          }
        }

        if(!this.admin.uuid) {
          this.$store.dispatch("dataAdmin/addAdmin", obj)              
          .then(() => {
            this.formClear(this.$t('ADD_ADMIN_SUCCESS'))
          })
          .catch(error => {
            if(error === "DUPLICATE_ADMIN_ID_MESSAGE"){
              this.errorAlert(this.$t("FAIL"), this.$t(error))
            }else{
              this.errorAlert(this.$t("ERROR"), error.message)
            }
            this.$vs.loading.close()
          })
        }else {
          this.$store.dispatch("dataAdmin/updateAdmin", obj)
          .then(() => {
            this.formClear(this.$t('UPDATE_ADMIN_SUCCESS'))
          })
          .catch(error => { 
            this.errorAlert(this.$t("ERROR"), error.message)
            this.$vs.loading.close()
          })
        } 
    },
    formClear(submitMessage){
        this.$vs.loading.close()
        this.$emit('closeSidebar')
        this.initValues() 
        this.successAlert(this.$t("SUCCESS"),submitMessage)
        this.$parent.$refs.adminTable.getData()
    },
    resetAdmin(){
      this.$vs.loading()
      this.$store.dispatch("dataAdmin/resetAdmin", this.admin.adminId)
        .then(() => {
          this.formClear(this.$t('RESET_ADMIN_SUCCESS'))
        })
        .catch(error => { 
          this.errorAlert(this.$t("ERROR"), error.message)
          this.$vs.loading.close()
        })
    },
    openConfirm(action) {
      
      let textMessage = ""
      let acceptAction =""

      if (action === "Submit") {
        textMessage = this.$t('SUBMIT_CONFIRM_MESSAGE')
        acceptAction = this.submitData
      } else if (action === "Reset"){
        textMessage = this.$t('RESET_CONFIRM_MESSAGE')
        acceptAction = this.resetAdmin
      }

      this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('CONFIRM'),
          text: textMessage,
          accept: acceptAction,
          acceptText: this.$t('CONFIRM'),
          cancelText: this.$t('CANCEL')
      })
    },
    getLabel(option) {
      return this.$t([option.text])
    },
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52004;
  }

  ::v-deep .vs-sidebar {
    z-index: 52004;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}

.admin-id-button{
    width:100%; 
    cursor: default;
}
</style>
